import * as XLSX from "xlsx";

// Fuente de verdad: back-sietegho modules/diagnostico/helpers/calcularFrp.js
// (array `structure`), confirmado con la sesión backend-siete el 2026-08-31.
// El backend hace match EXACTO de estos nombres de columna (mayúsculas y
// tildes incluidas) después de solo un trim alrededor del último guion
// (modules/diagnostico/controllers/excel.js, función `clearVar`). Un solo
// carácter distinto y el indicador correspondiente queda en 0 sin avisar.
export const RGO_COLUMNS = [
  "RGO-03-Liderazgo",
  "RGO-03-Relaciones Sociales",
  "RGO-03-Retroalimentación",
  "RGO-03-Relación Colaboradores",
  "RGO-03-LIDERAZGO Y RELACIONES SOCIALES EN EL TRABAJO",
  "RGO-04-Claridad de Rol",
  "RGO-04-Capacitación",
  "RGO-04-Participación y cambio",
  "RGO-04-Habilidades y conocimientos",
  "RGO-04-Control y Autonomía",
  "RGO-04-CONTROL SOBRE EL TRABAJO",
  "RGO-05-Dem ambientales y fís",
  "RGO-05-Dem emocionales",
  "RGO-05-Dem cuantitativas",
  "RGO-05-Influencia trabajo entorno",
  "RGO-05-Exigencias cargo",
  "RGO-05-Demandas de carga mental",
  "RGO-05-Consistencia de Rol",
  "RGO-05-Dem Jornada de Trabajo",
  "RGO-05-DEMANDAS DEL TRABAJO",
  "RGO-06-Recompensas del trabajo",
  "RGO-06-Reconocimiento",
  "RGO-06-RECOMPENSAS",
  "RGO-02-TOTAL FRP INTRALABORALES",
  "RGO-07-Tiempo Fuera del Trabajo",
  "RGO-07-Relaciones Familiares",
  "RGO-07-Comunicación",
  "RGO-07-Economía Familiar",
  "RGO-07-Vivienda",
  "RGO-07-Influencia Entorno Trabajo",
  "RGO-07-Desplazamiento",
  "RGO-07-TOTAL FRP EXTRALABORALES",
  "RGO-01-TOTAL FRP",
  "RGO-08-Optimismo",
  "RGO-08-Internalidad",
  "RGO-08-Autoestima",
  "RGO-08-Autoeficacia",
  "RGO-08-INDICADOR CONDICIONES INDIVIDUALES",
  "RGO-10-Agotamiento Emocional",
  "RGO-10-Cinismo",
  "RGO-10-Pérdida de Autoeficacia",
  "RGO-10-Burnout",
  "RGO-11-Estrés",
  "RGO-09-Engagement",
  "RGO-12-CASOS CRÍTICOS",
];

// modules/diagnostico/helpers/formaIntraTransforma.js: si el Excel trae estas
// columnas (match exacto o regex tolerante a espacios) ganan sobre el input
// manual "Forma A/B" del formulario de creación de proceso.
export const TRANSFORMA_COLUMNS = [
  "TOTAL INTRA TRANSFORMA A",
  "TOTAL INTRA TRANSFORMA B",
];

// Columnas de identificación/demografía de la plantilla vigente. No forman
// parte del contrato de calcularFrp.js: el parser de excel.js las acepta tal
// cual (cualquier header no-AGR se guarda como Grupo; el prefijo AGR- se
// reconoce genérico por posición de substring, no por nombre completo,
// confirmado en back-sietegho/modules/diagnostico/controllers/excel.js).
const IDENTITY_COLUMNS = [
  "AGR-year",
  "ID",
  "Nombre",
  "CONSENTIMIENTO",
  "DEM-T-Forma",
  "DEM-T-Nivel 1",
  "DEM-H-Nivel 2",
  "DEM-T-Nivel3",
  "DEM-T-Demográfico2",
  "DEM-T-Sexo",
  "DEM-B-Edad",
  "DEM-B-Demográfico3",
  "DEM-H-Demográfico4",
  "DEM-T-Demográfico5",
  "AGR-FORMA",
  "AGR-Nivel1",
  "AGR-Nivel2",
  "AGR-Nivel3",
  "AGR-Demografico1",
  "AGR-Demografico2",
  "AGR-Demografico3",
  "AGR-Demografico4",
];

export function generateFrpTemplate(
  extraColumns = [],
  fileName = "Estructura de datos frsm.xlsx"
) {
  const headers = [
    ...IDENTITY_COLUMNS,
    ...RGO_COLUMNS,
    ...TRANSFORMA_COLUMNS,
    "COMENTARIO",
    ...extraColumns,
  ];

  const wb = XLSX.utils.book_new();
  const wsDatos = XLSX.utils.aoa_to_sheet([headers]);
  XLSX.utils.book_append_sheet(wb, wsDatos, "ESTRUCTURA DE DATOS");

  XLSX.writeFile(wb, fileName);
}



// WEBPACK FOOTER //
// ./src/components/frpm/helpers.js